import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatRadioGroup, MatRadioModule } from "@angular/material/radio";
import { MatIconModule } from "@angular/material/icon";

import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FeedbackSubmissionComponent } from '../../setup/feedback/feedback-submission/feedback-submission.component';


@Component({
  selector: 'app-complition-details',
  imports: [MatTabsModule, MatExpansionModule, MatRadioModule, MatIconModule, MatSelectModule, MatInputModule,
    MatFormFieldModule, FeedbackSubmissionComponent],
  templateUrl: './complition-details.component.html',
  styleUrl: './complition-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComplitionDetailsComponent {
readonly panelOpenState = signal(false);
}
